export default {
  title: 'Reforma Tributária',
  image: require('@/assets/images/post/hero-reformatributaria.jpg'),
  credits: 'Crédito André Teixeira/Oxfam Brasil',
  subtitle: 'A tributação tem que reduzir a concentração de renda e financiar serviços públicos de qualidade.',
  content: [
    {
      type: 'text',
      data: `
        <p>Para reduzir as desigualdades no país, precisamos de uma reforma tributária que efetivamente redistribua os recursos daqueles que têm mais para aqueles que mais precisam. </p>
        <p>Uma tributação mais justa, que reduza a concentração de renda, é algo que a maioria dos países desenvolvidos já resolveram.</p>`,
    },
    {
      type: 'chart',
      data: {
        title: 'Oxfam Brasil - Carga tributária, Brasil versus países da OCDE - 2015',
        id: 'infogram_0_b9bf8fe1-0e64-4f30-9633-d28ddeafe2c5',
        link: 'https://infogram.com/oxfam-brasil-carga-tributaria-brasil-versus-paises-da-ocde-2015-1h0n25j3xmyo6pe'
      },
    },
    {
      type: 'text',
      data: `
        <p>Apesar de nossa carga tributária bruta girar em torno de 33% do PIB – nível similar ao dos países da Organização para a Cooperação e o Desenvolvimento Econômico (OCDE) -, ela é mal distribuída. Os mais pobres e a classe média pagam mais impostos, proporcionalmente, do que pessoas com rendas muito altas.</p>
        <p>Considerando os países da lista da OCDE (membros e aliados), figuramos entre os únicos três cujos tributos indiretos (consumo) superam os diretos (renda e patrimônio) na composição da carga tributária. </p>
        <p>A maioria das grandes economias do planeta sustentam sua arrecadação mais sobre tributos de renda e patrimônio do que sobre tributos de bens e serviços – as exceções são o Brasil, a Turquia e o Chile.</p>
        <p>O Brasil é o que menos tributa renda e patrimônio como proporção da carga tributária bruta (CTB), pouco mais de 22%. Na média da OCDE, esse nível é de 40%. Por outro lado, a tributação indireta brasileira chega a quase 50%, enquanto na OCDE não passa de 33% na média.</p>`,
    },
    {
      type: 'chart',
      data: {
        title: 'OCDE - Carga tributária bruta e proporção dos tributos em sua composição - 2015',
        id: 'infogram_0_1dac3305-22c5-4ddc-8887-3e56c01d6f42',
        link: 'https://infogram.com/ocde-carga-tributaria-bruta-e-proporcao-dos-tributos-em-sua-composicao-2015-1h0r6rqe83r74ek'
      },
    },
    {
      type: 'text',
      data: `
        <p>Sabemos que a parcela muito rica da população paga poucos impostos proporcionalmente à renda e patrimônio. Também existem muitos casos de evasão e sonegação de recursos. </p>
        <p>Isso limita a capacidade do Estado oferecer serviços públicos universais de qualidade. E é justamente por isso que defendemos uma reforma tributária justa e solidária, onde as diferentes parcelas da sociedade paguem os impostos de forma balanceada com suas realidades. Sem justiça fiscal, a injustiça social não terá fim.</p>`,
    },
  ],
};
